export const SUBJECT_CONSTANTS = {
  ALL_SUBJECTS: "All Subjects",
  STATUS_OPEN: "Open",
  STATUS_CLOSE: "Close",
  DELETE_MESSAGE: `Your data will be lost permanently, cant be retrieved.`,
  DELETE_FOOTER_CONTENT: `Are your sure you want to Proceed.`,
  ALL_SUBJECT_KEY: "all-subjects",
};

export const USER_CONSTANTS = {
  ALL_USERS: "Users",
  USERS: "Users,",
  USER_ROLE: "SUPER_USER",
  QUESTION_ADDER: "QUESTION_ADDER",
  QUESTION_VERIFIER: "QUESTION_VERIFIER",
  USER_EMAIL: "ravi.r@fireflink.com",
  TRAINER: "TRAINER",
  SUBJECT_OWNER: "SUBJECT_OWNER",
  SUPER_USER: "SUPER_USER",
  STUDENT: "STUDENT",
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  SUPER_ADDER: "SUPER_ADDER",
  SUPER_VERIFIER: "SUPER_VERIFIER",
  TASK_MANAGER: "TASK_MANAGER",
  SUPER_TASK_MANAGER: "SUPER_TASK_MANAGER",
  SUPER_TRAINER: "SUPER_TRAINER",
};

export const SYLLABUS_CONSTANTS = {
  SYLLABUS_HEADING: "Syllabus",
};

export const ORG_BRANCH_CONSTANTS = {
  BRANCH_HEADING: "Branch",
};

export const ORG_BATCH_CONSTANTS = {
  BATCH_HEADING: "Batch",
};

export const SHARED_QUESTIONS_CONSTANTS = {
  SHARED_QUESTIONS_HEADING: "Shared Questions",
};

export const LOCALSTORAGE_KEYS = {
  SELECTED_MENUITEM: "selectedMenuItem",
  SUBJECT_OPTIONS: "subjectOptions",
  SELECTED_PROJECT: "selectedProject",
};
export const NO_DATA_FOUND = {
  NO_USER_FOUND: "No User Found",
  NO_SUBJECT_FOUND: "No Subject Found",
};

export const ICON_BUTTON_CONSTANTS = {
  ADD_USER: "User",
  ADD_SUBJECT: "Subject",
  ADD_SYLLABUS: "Syllabus",
  ADD_QUESTION: "Question",
  ADD_QUIZ: "Test",
  ADD_BATCH: "Batch",
  JOIN_BATCH: "Join Batch",
  ADD_BRANCH: "Branch",
  ASSIGN: "Assign",
  ASSIGN_GROUP: "Assign Group",
  ROW: "Row",
};

export const ERROR_MSGS_CONSTANTS = {
  NAME_MIN_ERR_MSG: "Name must be at least 3 characters long",
  NAME_MAX_ERR_MSG: "Name must not be  more than 100 characters",
  NAME_SPL_ERR_MSG:
    "Name must not contain any spaces or special characters or numbers",
  NAME_REQUIRED: "Name is required",
  PROGRAMMING_LANGUAGE_REQUIRED: "Programming Language is Required",
  CATEGORY_REQUIRED: "Category is required",
  QUESTION_TYPE_REQUIRED: "Question type is required",
  DESCRIPTION_REQUIRED: "Description is required",
  DURATION_REQUIRED: "Duration is required",
  DURATION_NUM_ERROR: "Duration must be a number",
  DURATION_ERROR: "Duration must be greater than 0.1",
  EMAIL_NOT_VALID: "Email must be valid",
  EMAIL_REQUIRED: "Email is required",
  PHONE_NOT_VALID: "Phone Number is not valid",
  PHONE_REQUIRED: "Phone Number is required",
  PRIVILEGE_REQUIRED: "Privilege is required",
  DESCRIPTION_MIN_ERROR:
    "Description must be at least 5 characters long and it should not exceed 200 characters",
  CHAPTER_NAME_ERROR: "Special characters are not allowed.",
  BATCH_CODE_REQUIRED: "Batch Code Required",
  SELECT_ERROR: "Select",
  PHONE_LENGTH: "Phone numbers must be 10 digits",
  PINCODE_NOT_VALID: "Pincode must be 6 digits",
  SUBJECT_REQUIRED: "Subject is required",
};

export const DRAWER_CONSTANTS = {
  CREATE: "Create",
  CANCEL: "Cancel",
  ADD: "Add",
  ASSIGN: "Assign",
  SUBJECT_TITLE: "Create Subject",
  MODULE_TITLE: "Create Module",
  CHAPTER_TITLE: "Create Chapter",
  USER_TITLE: "Add User",
  ADD_USER_TO_SUBJECT: "Add User to Subject",
  EDIT: "Update",
  EDIT_SUBJECT: "Update Subject",
  ADD_USER_TO_SYLLABUS: "Add User to Syllabus",
  SELECT_CHAPTER: "Select",
  SELECT_CHAPTER_TITLE: "Select Chapter/Topic",
  TAG_QUESTION: "Tag Question",
  TAG_QUESTION_TITLE: "Tag Similar Question",
  QUESTION_SUMMARY: "Question Summary",
  QUIZ_SUMMARY: "Test Summary",
  CREATE_QUIZ: "Create Test",
  QUESTIONS_ADDED: "Questions Added",
  CREATE_NEW_BATCH: "Create New Batch",
  STUDENTS: "Students",
  QUIZ: "Test",
  BATCHES: "Batches",
  SUBMIT: "Submit",
  JOIN_NEW_CLASS: "Join New Class",
  START_END_DATE: "Start, End Date & Time",
  CREATE_TOURNAMENT: "Create Tournament",
  PROCEED: "Proceed",
  REPLACE: "Replace",
  CREATE_CATEGORY: "Create Category",
  CREATE_COMPANY: "Create Company",
  CREATE_TOPIC: "Create Topic",
  CREATE_LIST: "Create List",
  CHANGE_PARENT: "Change Parent",
};

export const LABEL_CONSTANTS = {
  NAME: "Name",
  CATEGORY: "Category",
  SUBJECT: "Subject",
  CHAPTER: "Chapter",
  TOPIC: "Topic",
  SUB_TOPIC: "Sub Topic",
  MARKS_TYPE: "Marks Type",
  QUESTION_TYPE: "Question Type",
  DESCRIPTION: "Description",
  OVERVIEW: "Overview",
  TOGGLE_STATUS: "Status",
  TOGGLE_OPEN: "Open",
  TOGGLE_CLOSE: "Close",
  DURATION: "Duration",
  EMAIL: "Email",
  PRIVILEGE: "Privilege",
  SELECT_CHAPTER: "Select Chapter",
  SELECT_TOPIC: "Select Topic",
  TAG_CHAPTER: "Chapter",
  TAG_TOPIC: "Topic",
  TAG_SUB_TOPIC: "Sub Topic",
  QUESTION_TITLE: "Question Title",
  APPLICATION: "Application",
  EVALUATIONS: "Evaluations",
  SHARE_OPTION: "Share Option",
  CHAPTER_TOPIC: "Chapter/Topic",
  QUEST_DESCRIPION_TITLE: "Question Description",
  DIFFICULTY_LEVEL: "Difficulty Level",
  MARKS: "Marks",
  SOURCE_CATEGORY: "Source Category",
  SOURCE: "Source",
  EXECUTION_COMPONENT: "Execution Component",
  QUIZ_TASK_NAME: "Test Name",
  START_BY_DURATION: "Start by Duration",
  END_BY_DURATION: "End by Duration",
  QUIZ_DESCRIPTION: "Description",
  QUIZ_DURATION: "Duration",
  TOTAL_QUESTIONS: "Total Questions",
  TOTAL_CHAPTERS: "Total Chapters",
  TOTAL_TOPICS: "Total Topics",
  TOTAL_SUB_TOPICS: "Total Sub Topics",
  TOTAL_SECTIONS: "Total Sections",
  QUIZ_DIFFICULTY_LEVEL: "Difficulty Level",
  ACTUAL_ANSWER: "Actual Answer",
  SHUFFLE_OPTIONS: "Shuffle Options",
  SHOW_RESULT: "Show Result",
  SOLUTION: "Solution",
  LOGIC_COMPONENT: "User Template",
  TEST_CASE: "Test Case",
  SAMPLE_INPUT: "Sample Input",
  EXPECTED_OUTPUT: "Expected Output",
  TOTAL_MARKS: "Total Marks",
  OPTIONS: "Options",
  QUIZ_NAME: "Quiz Name",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  COMPANY_LEVEL: "Company Level",
};

export const ADD_USER_TO_SUBJECT_CONSTANTS = {
  NO_USER_AVAILABLE: "No user available",
};

export const SUBJECT_CATEGORY_OPTIONS = [
  { label: "Backend", name: "Backend", value: "Backend" },
  { label: "Frontend", name: "Frontend", value: "Frontend" },
];

export const LEVEL_OPTIONS_SUPER_ADMIN = [
  { label: "Organization", name: "Organization", value: "Organization" },
  {
    label: "Sub Organization",
    name: "Sub Organization",
    value: "Sub Organization",
  },
];

export const LEVEL_OPTIONS = [
  { label: "Organization", name: "Organization", value: "Organization" },
  {
    label: "Sub Organization",
    name: "Sub Organization",
    value: "Sub Organization",
  },
  {
    label: "Branch",
    name: "Branch",
    value: "Branch",
  },
  {
    label: "Batch",
    name: "Batch",
    value: "Batch",
  },
];

export const SUBJECT_QUESTION_TYPE_OPTIONS = [
  { name: "MCQ", value: "MCQ", label: "MCQ" },
  { name: "PROGRAMMING", value: "PROGRAMMING", label: "PROGRAMMING" },
  { name: "PROJECT", value: "PROJECT", label: "PROJECT" },
  { name: "PSYCHOMETRIC", value: "PSYCHOMETRIC", label: "PSYCHOMETRIC" },
  // { name: "Descriptive", value: "Descriptive" },
];

export const SUBJECT_QUESTION_TYPE_QUIZ = [
  { name: "MCQ", value: "MCQ", label: "MCQ" },
  { name: "PROGRAMMING", value: "PROGRAMMING", label: "PROGRAMMING" },
];

export const GENERIC_QUESTION_TYPE_QUIZ = [
  { name: "MCQ", value: "MCQ", label: "MCQ" },
  { name: "DESCRIPTIVE", value: "DESCRIPTIVE", label: "Descriptive" },
  { name: "ESSAY", value: "ESSAY", label: "Essay" },
  { name: "BLANKS", value: "BLANKS", label: "Blanks" },
  { name: "SHORT_ANSWERS", value: "SHORT_ANSWERS", label: "Short Answers" },
  { name: "NUMERIC", value: "NUMERIC", label: "Numeric" },
  { name: "FRACTION", value: "FRACTION", label: "FRACTION" },
  {
    name: "QUANTITATIVE_COMPARISON",
    value: "QUANTITATIVE_COMPARISON",
    label: "Quantitative Comparison",
  },
  {
    name: "MATCH_THE_FOLLOWING",
    value: "MATCH_THE_FOLLOWING",
    label: "Match the Following",
  },
  {
    name: "SELECT_IN_PASSAGE",
    value: "SELECT_IN_PASSAGE",
    label: "Select In Passage",
  },
  { name: "SPEAKING", value: "SPEAKING", label: "Speaking" },
  { name: "LISTENING", value: "LISTENING", label: "Listening" },
  { name: "CUE_CARD", value: "CUE_CARD", label: "Cue Card" },
  { name: "DISCUSSION", value: "DISCUSSION", label: "Discussion" },
  {
    name: "IDENTIFYING_INFORMATION",
    value: "IDENTIFYING_INFORMATION",
    label: "Identifying Information",
  },
  {
    name: "MULTIPLE_SENTENCE_ENDINGS",
    value: "MULTIPLE_SENTENCE_ENDINGS",
    label: "Multiple Sentence Endings",
  },
  {
    name: "NOTE_COMPLETION",
    value: "NOTE_COMPLETION",
    label: "Note Completion",
  },
  {
    name: "SENTENCE_COMPLETION",
    value: "SENTENCE_COMPLETION",
    label: "Sentence Completion",
  },
  {
    name: "SUMMARY_COMPLETION",
    value: "SUMMARY_COMPLETION",
    label: "Summary Completion",
  },
  {
    name: "SUMMARY_COMPLETION_BLANKS",
    value: "SUMMARY_COMPLETION_BLANKS",
    label: "Summary Completion Blanks",
  },
  {
    name: "MATCHING_FEATURES",
    value: "MATCHING_FEATURES",
    label: "Matching Features",
  },
  {
    name: "PLAN_MAP_DIAGRAM_LABELLING",
    value: "PLAN_MAP_DIAGRAM_LABELLING",
    label: "Plan/Map/Diagram Labelling",
  },
  {
    name: "TABLE_COMPLETION",
    value: "TABLE_COMPLETION",
    label: "Table Completion",
  },
];

export const SOURCE_CATEGORY_OPTIONS = [{ name: "Sample", value: "Sample" }];

export const RELATED_EXAM_OPTIONS = [
  { label: "Exam 1", value: "Exam 1", name: "Exam 1" },
  { label: "Exam 2", value: "Exam 2", name: "Exam 1" },
];
export const APPLICATION_OPTIONS = [
  { name: "ELP", value: "ELP" },
  { name: "QLABS", value: "QLABS" },
  { name: "TESTFRESHERS", value: "TESTFRESHERS" },
];
export const APPLICATION_MCQ_OPTIONS = [
  { name: "ELP", value: "ELP" },
  { name: "QLABS", value: "QLABS" },
  { name: "TESTFRESHERS", value: "TESTFRESHERS" },
];
export const APPLICATION_PROGRAMMING_OPTIONS = [
  { name: "ELP", value: "ELP" },
  { name: "QLABS", value: "QLABS" },
  { name: "TESTFRESHERS", value: "TESTFRESHERS" },
];
export const PROGRAMMING_LANGUAGE = [
  { name: "Java", value: "Java" },
  { name: "HTML", value: "HTML" },
  { name: "CSS", value: "CSS" },
  { name: "Javascript", value: "Javascript" },
  { name: "TypeScript", value: "TypeScript" },
  { name: "Python", value: "Python" },
  { name: "C Sharp", value: "Csharp" },
];

export const PROGRAMMING_TYPE = [
  { name: "UNORDER", value: "UNORDER" },
  { name: "CONSOLE_BASED", value: "CONSOLE_BASED" },
  { name: "ORDER", value: "ORDER" },
  { name: "SAME_OBJECT_ORDER", value: "SAME_OBJECT_ORDER" },
  { name: "SAME_OBJECT_UNORDER", value: "SAME_OBJECT_UNORDER" },
  { name: "SCANNER_BASED", value: "SCANNER_BASED" },
];

export const ANSWER_MODE_OPTIONS = [
  { name: "Manual", value: "MANUAL" },
  { name: "Prompt", value: "PROMPT" },
];

export const EVALUATION_MODE_OPTIONS = [
  { name: "Partial", label: "Partial", value: "PARTIAL" },
  { name: "Full", label: "Full", value: "FULL" },
];

export const DIFFICULTY_LEVEL_OPTIONS = [
  { name: "Easy", value: "Easy" },
  { name: "Medium", value: "Medium" },
  { name: "Hard", value: "Hard" },
];

export const COMPANY_OPTIONS = [
  { name: "Sample", value: "Sample" },
  { name: "Company 2", value: "Company 2" },
  { name: "Company 3", value: "Company 3" },
];
export const KEYWORD_OPTIONS = [
  { name: "Keyword 1", value: "Keyword 1" },
  { name: "Keyword 2", value: "Keyword 2" },
  { name: "Keyword 3", value: "Keyword 2" },
];
export const USER_PRIVILEGE_OPTIONS = [
  // { label: "SUPER_USER", name: "SUPER_USER", value: "SUPER_USER" },
  { label: "ADMIN", name: "ADMIN", value: "ADMIN" },
  // { label: "SUBJECT_OWNER", name: "SUBJECT_OWNER", value: "SUBJECT_OWNER" },
  { label: "QUESTION_ADDER", name: "QUESTION_ADDER", value: "QUESTION_ADDER" },
  {
    label: "QUESTION_VERIFIER",
    name: "QUESTION_VERIFIER",
    value: "QUESTION_VERIFIER",
  },
  { label: "TRAINER", name: "TRAINER", value: "TRAINER" },
  { label: "TASK_MANAGER", name: "TASK_MANAGER", value: "TASK_MANAGER" },
];

export const SUPER_ADMIN_PRIVILEGE_OPTIONS = [
  {
    label: "SUPER_ADDER",
    name: "SUPER_ADDER",
    value: "SUPER_ADDER",
  },
  {
    label: "SUPER_VERIFIER",
    name: "SUPER_VERIFIER",
    value: "SUPER_VERIFIER",
  },
  {
    label: "SUPER_TASK_MANAGER",
    name: "SUPER_TASK_MANAGER",
    value: "SUPER_TASK_MANAGER",
  },
  {
    label: "SUPER_TRAINER",
    name: "SUPER_TRAINER",
    value: "SUPER_TRAINER",
  },
];

export const DURATION_OPTIONS = [
  { label: "Min", name: "Min", value: "Min" },
  { label: "Sec", name: "Sec", value: "Sec" },
];

export const SECTION_OPTIONS = [
  { label: "Section 1", name: "Section 1", value: "Section 1" },
  { label: "Section 2", name: "Section 2", value: "Section 2" },
];

export const BACKEND_PROGRAMMING_LANGUAGE = [
  { name: "Java", value: "Java" },
  { name: "Javascript", value: "Javascript" },
  { name: "Python", value: "Python" },
];
export const FRONTEND_PROGRAMMING_LANGUAGE = [
  { name: "HTML", value: "HTML" },
  { name: "CSS", value: "CSS" },
  { name: "Javascript", value: "Javascript" },
];

export const FRONTEND_SUBJECT_OPTIONS = [
  {
    label: "HTML",
    name: "HTML",
    value: "HTML",
  },
  {
    label: "CSS",
    name: "CSS",
    value: "CSS",
  },
  {
    label: "Javascript",
    name: "Javascript",
    value: "Javascript",
  },
];

export const CREATE_CHAPTER_DRAWER_CONSTANTS = {
  ACTION_TYPE_MODULE: "module",
  ACTION_TYPE_CHAPTER: "chapter",
  ACTION_TYPE_TOPIC: "topic",
  ACTION_TYPE_SUB_TOPIC: "sub topic",
  TIME_UNIT_SECS: "Sec",
  TIME_UNIT_MINS: "Min",
};

export const TOAST_MESSAGE = {
  EDIT_SUBJECT_SUCCESS: "Subject Updated SuccessFully",
  EDIT_SUBJECT_ERROR: "Error in Updating the Subject",
  ADD_SUBJECT_SUCCESS: "Subject Added SuccessFully",
  ADD_SUBJECT_ERROR: "Error in Adding the Subject",
  DELETE_SUBJECT_SUCCESS: "Subject Deleted Successfully",
  DELETE_SUBJECT_ERROR: "Failed to Delete Subject",
  ADD_USER_SUCCESS: "User added successfully",
  ADD_USER_ERROR: "Failed to add user",
  CREATE_MODULE_SUCCESS: "Module created successfully",
  CREATE_CHAPTER_SUCCESS: "Chapter created successfully",
  CREATE_TOPIC_SUCCESS: "Topic created successfully",
  CREATE_SUB_TOPIC_SUCCESS: "Sub topic created successfully",
  CREATE_SYLLABUS_SUCCESS: "Syllabus created successfully",
  UPDATE_SYLLABUS_SUCCESS: "Syllabus updated successfully",
};

export const CREATE_SYLLABUS = {
  TITLE: "Create Syllabus",
  EDIT_TITLE: "Edit Syllabus",
  TREE_HEAD: "Select Chapter/Topic/Sub Topic",
  TREE_SUB_HEAD: "SUBJECTS",
  SUBMIT_BTN_TITLE: "Create",
  SUBMIT_BTN_EDIT: "Update",
};

export const ERROR_MSGS_CREATE_SYLLABUS = {
  NAME_MIN_ERR_MSG: "Name must be at least 3 characters long",
  NAME_MAX_ERR_MSG: "Name must be no more than 50 characters long",
  NAME_SPL_ERR_MSG: "Name must not contain special characters or numbers",
  NAME_REQUIRED: "Name is required",
};

export const QUESTION_COUNT_LABELS = {
  totalQuestions: "Total Questions :",
  globalQuestions: "Global Questions :",
  approvedQuestions: "Verified :",
  pendingQuestions: "Pending :",
  rejectedQuestions: "Rejected :",
  myQuestions: "My Questions :",
};

export const QUIZ_SUMMARY_CONSTANTS = {
  QUIZ_QUESTION_TABLE_TITLE: "Questions Added",
};

export const CREATE_QUIZ_CONSTANTS = {
  TITLE: "Create Test",
  EDIT_TITLE: "Edit Test",
  SUB_TITLE: "Added Questions",
  QUIZ_TYPE: "Quiz Type",
  SECTION: "Sections",
  ADD_NEW: "Add New Section",
  TASK_NAME: "Enter Test Name",
  TEST_TYPE: "Test Type",
  DURATION: "Duration",
  START_BY: "Start by Duration",
  END_BY: "End by Duration",
  SECTION_TITLE: "Section Name",
  MARKS_TYPE: "Marks Type",
  DESCRIPTION: "Test Description",
  START_DURATION_ERROR: "At least one of the Start fields should be filled",
  END_DURATION_ERROR: "At least one of the End fields should be filled",
  ASSIGN: "Assign",
  PROBLEM_STATEMENT: "Problem Statement",
  MALPRACTICE_COUNT: "Malpractice Count",
};

export const CREATE_TOURNAMENT_CONSTANTS = {
  TITLE: "Create Tournament",
  EDIT_TITLE: "Edit Tournament",
  SUB_TITLE: "Added Questions",
  TASK_NAME: "Enter Tournament Name",
  DURATION: "Duration",
  START_BY: "Start by Duration",
  END_BY: "End by Duration",
  DESCRIPTION: "Tournament Description",
  BUFFER_TIME_LABEL: "Tournament Buffer Time",
  START_DURATION_ERROR: "At least one of the Start fields should be filled",
  END_DURATION_ERROR: "At least one of the End fields should be filled",
};

export const CREATE_QUIZ_QUESTION_TYPE = [
  {
    value: "automatic",
    label: "Automatic",
  },
  {
    value: "manual",
    label: "Manual",
  },
];

export const MODE_OF_CLASS_CONSTANTS = [
  { name: "Online", value: "Online" },
  { name: "Offline", value: "Offline" },
];

export const QUIZ_DETAILS_CONSTANT = {
  TOTAL_STUDENTS: "Total Students",
  TOTAL_QUIZ: "Total Test",
  YET_TO_ATTEMPT: "Yet to Attempt",
  STATUS: "Status",
  ATTENDED: "Attended",
  TOTAL_QUESTIONS: "Total Question",
  NOT_ATTENDED: "Not Attended",
  TOTAL_MARKS: "Total Marks",
  IN_PROGRESS: "In Progress",
  QUIZ_NAME: "Test Name",
  STUDENT_NAME: "Student Name",
  ATTEMPT: "Attempt",
  MARKS: "Marks",
  QUESTION: "Question",
  DESCRIPTION: "Description",
  EXAMPLE: "Example",
};

export const ORGANIZATION_CONSTANTS = {
  NUMBER: "+91-7338471266",
  EMAIL: "help@qspiders.com",
  FEEDBACK: "Feedback",
};

export const PROFILE_DETAILS_CONSTANTS = {
  BATCHES: "Batches",
  SUBJECTS: "Subjects",
};
export const STUDENT_EVALUATION_CONSTANTS = {
  SUMMARY: "Summary",
  ANSWERS: "Answers",
  SUBMIT_SUCCESSFUL: "Test submitted successful",
  CONGRAGULATIONS_TEXT: "Congratulations you have Completed the Test",
  QUIZ_SUMMARY: "Test Summary",
};

export const STUDENT_BATCH_CONSTANTS = {
  BATCHES: "Batches",
  BATCH_ACCESSIBLE_ONLY_IN_ELP_APP: "Batch is accessible in Elp app only",
};
export const VALIDATION_CONSTANTS = {
  INVALID_EMAIL: "Invalid email",
  EMAIL_REQUIRED: "Email is required",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_MIN_LENGTH: "Password must be at least 8 characters",
  CONFIRM_PASSWORD_REQUIRED: "Confirm Password is required",
  PASSWORDS_MUST_MATCH: "Passwords must match",
  GENDER_REQUIRED: "Gender is required",
};

export const LOGIN_PAGE_CONSTANTS = {
  WELCOME_HEADING: "Sign In",
  WELCOME_DESCRIPTION: "Glad you’re back.!",
  CREATE_ACCOUNT_HEADING: "Signup",
  CREATE_ACCOUNT_SUB_HEADING: "Just some details to get you in.!",
  EMAIL_LABEL: "Email",
  EMAIL_PLACEHOLDER: "Enter your email address",
  PASSWORD_LABEL: "Password",
  PASSWORD_PLACEHOLDER: "Enter your password",
  CONFIRM_PASSWORD_LABEL: "Confirm Password",
  CONFIRM_PASSWORD_PLACEHOLDER: "Re-enter your password",
  REMEMBER_ME: "Remember Me",
  FORGOT_PASSWORD: "Forgot Password ?",
  LOGIN_BUTTON: "Sign In",
  REGISTER_BUTTON: "Sign up",
  ACCOUNT_EXSISTING: "Already Registered?",
  CREATE_ACCOUNT: "Don't have an account ?",
  NAME: "Username",
  NAME_PLACEHOLDER: "Enter your name",
  PHONE_NUMBER: "Phone Number",
  PHONE_NUMBER_PLACEHOLDER: "+91",
};

export const STUDENT_ELP_BUTTON_CONSTANT = {
  PREVIOUS: "Previous",
  NEXT: "Next",
  SUBMIT: "Submit",
  CANCEL: "Cancel",
};

export const SUBJECT_TYPE_CONSTANTS = {
  SUBJECT: "SUBJECT",
  MODULE: "MODULE",
  CHAPTER: "CHAPTER",
  TOPIC: "TOPIC",
  SUB_TOPIC: "SUBTOPIC",
};

export const PASSWORD_VALIDATION = {
  CHARACTER_LIMIT: "Between 8 to 20 Characters",
  UPPERCASE: "1 Uppercase Character",
  SPECIAL_CHARACTER: "1 Special Character",
  LOWER_CASE: "1 Lowercase Character",
  NUMBER: "1 Number",
};

export const FORM_COMMON_CONSTANTS = {
  SUBMIT_BTN_CREATE: "Create",
  SUBMIT_BTN_UPDATE: "Update",
  CANCEL_BTN_TITLE: "Cancel",
  CATEGORY: "Category",
  LEVEL: "Select Level",
  ORGANIZATION: "Select Organization",
  SUBORGANIZATION: "Select Sub Organization",
  NAME: "Name",
  EMAIL: "Email",
  PHONE: "Phone Number",
  ADDRESS: "Address",
  COUNTRY: "Country",
  STATE: "State",
  PINCODE: "Pin Code",
  ADMINNAME: "Admin Name",
  ADMINEMAIL: "Admin Email Id",
  ADMINPHONE: "Admin Phone Number",
  SUBJECTS: "Select Subject",
  MALPRACTICE_COUNT: "Malpractice Count",
  BACK: "Back",
};

export const CREATE_ORGANIZATION = {
  ORG_CREATE_TITLE: "Create Organization",
  ORG_UPDATE_TITLE: "Update Organization",
};

export const CREATE_SUB_ORGANIZATION = {
  SUB_ORG_CREATE_TITLE: "Create Sub Organization",
  SUB_ORG_UPDATE_TITLE: "Update Sub Organization",
};

export const CREATE_BRANCH = {
  BRANCH_CREATE_TITLE: "Create Branch",
  BRANCH_UPDATE_TITLE: "Update Branch",
  CLIENT_UPDATE_TITLE: "Update Client",
  CLIENT_CREATE_TITLE: "Create Client",
};

export const ORG_LEVEL_OPTIONS = [
  {
    value: "ORGANIZATION",
    name: "Organization",
  },
  {
    value: "SUB_ORGANIZATION",
    name: "Sub Organization",
  },
];

export const CREATE_BATCH_CONSTANTS = {
  LEVEL: "Select Level",
  ORGANIZATION: "Select Organization",
  SUBORG: "Sub Organization",
  BRANCH: "Branch",
  SUBJECTS: "Subject",
  TRAINER: "Trainer",
  STARTDATE: "Start date and time",
  MODEOFCLASS: "Mode of Class",
  isTASKROOM: "Task Room",
  ISAUTOASSIGN: "Auto Assign Test",
  EXPIRYDATE: "Test Expiry Duration",
  ATTENDANCE_ALLOWED: "Attendace Allowed",
  IS_PUBLIC: "Public Batch",
  BATCH_TYPE: "Batch Type",
};

export const ORGCATEGORYOPTIONS = [
  { name: "SCHOOL", value: "SCHOOL" },
  {
    name: "COLLEGE/UNIVERSITY",
    value: "COLLEGE",
  },
  { name: "OFFICE", value: "OFFICE" },
  { name: "INSTITUTION", value: "INSTITUTION" },
];

export const TASK_MANAGER_QUIZ_FORM_CONSTANTS = {
  CREATE: "Create Quiz",
  EDIT: "Update Quiz",
  NAME: "Enter Quiz Name",
  DURATION: "Duration",
  DESCRIPTION: "Quiz Description",
  SHOW_RESULT: "Show Result",
  ACTUAL_ANSWER: "Actual Answer",
  SHUFFLE_QUESTIONS: "Shuffle Questions",
  TOAST_ERROR_Questions:
    "Please fill all required fields and assign questions.",
  PASS_PERCENTAGE: "Pass Percentage",
  MALPRACTICE_COUNT: "Malpractice Count",
};
export const months: string[] = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const reversedMonths: string[] = [
  "December",
  "November",
  "October",
  "September",
  "August",
  "July",
  "June",
  "May",
  "April",
  "March",
  "February",
  "January",
];

export const ENROLLMENT_TYPE = [
  { value: "INTERNAL", name: "INTERNAL" },
  { value: "EXTERNAL", name: "EXTERNAL" },
];

export const MARKS_TYPE = [
  { label: "UNIFORM", value: "UNIFORM" },
  { label: "INDIVIDUAL", value: "INDIVIDUAL" },
  {
    label: "ORIGINAL",
    value: "ORIGINAL",
  },
];

export const WEIGHTAGE_OPTIONS = Array.from({ length: 10 }, (_, i) => ({
  name: `${i + 1}`,
  value: i + 1,
}));

/** Report analytics for attendance constant variables */
export const ANALYTICS_CONSTANTS = {
  PERFECT: "EXCELLENT",
  COMPLIANT: "GOOD",
  AT_RISK: "AT_RISK",
  DEFAULTER: "DEFAULTER",
};

export const BATCH_STATUS_ENUM = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  UPCOMING: "UPCOMING",
};

export const GRADE_ENUM = {
  A_PLUS: "A+",
  A: "A",
  B_PLUS: "B+",
  B: "B",
  C_PLUS: "C+",
  C: "C",
  D: "D",
  F: "F",
};

export const ATTENDANE_PERFORMANCE_ENUM = {
  TOP_PERFORMER: "TOP_PERFORMERS",
  AVERAGE_PERFORMER: "AVERAGE PERFORMERS",
  POOR_PERFORMER: "POOR PERFORMERS",
};

export const MONTH_FILTER_OPTIONS = [
  { label: "Current Month", value: "current" },
  { label: "Last Month", value: "last" },
  { label: "2 Months", value: "2months" },
  { label: "3 Months", value: "3months" },
];

export const LEVEL_CONSTANTS = {
  SUPER_ORGANIZATION: "SUPER_ORGANIZATION",
  ORGANIZATION: "ORGANIZATION",
  SUB_ORGANIZATION: "SUB_ORGANIZATION",
  BRANCH: "BRANCH",
};
export enum PRACTICE_MODE {
  PRACTICE = "Practice",
  CODE = "Code",
}

export const NON_AUDIO_QUESTION_TYPES = [
  "PROGRAMMING",
  "FRONTEND",
  "PROJECT",
  "PSYCHOMETRIC",
  "BASH",
  "JENKINS",
  "KUBERNETES",
  "DEVOPS_TASK_BASED",
  "PROJECT_EXECUTION",
  "DESCRIBE_IMAGE",
  "READ_ALOUD",
  "SNIPPET",
];

export const AUDIO_QUESTION_TYPES = [
  "REPEAT_SENTENCE",
  "RETELL_LECTURE",
  "CUE_CARD",
  "DISCUSSION",
];
